import React from 'react';

export default function LoadingOverlay({ isVisible = false }) {
    if (!isVisible) return null; // Don't render if not visible

    return (
        <div className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50">
            <div className="tw-flex tw-flex-col tw-items-center">
                <div className="tw-w-12 tw-h-12 tw-border-[4px] tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
                <p className="tw-mt-3 tw-text-white tw-text-lg">Loading...</p>
            </div>
        </div>
    );
}
